import GenerateEnum from "../generateEnum";

export const USAStateEnum = new GenerateEnum({
  NEW_YORK: {
    value: "NY",
    zhName: "纽约州",
    enName: "New York",
    i18nKey: "remote.common.USAState.NEW_YORK"
  },
  PUERTO_RICO: {
    value: "PR",
    zhName: "波多黎各",
    enName: "Puerto Rico",
    i18nKey: "remote.common.USAState.PUERTO_RICO"
  },
  VIRGIN_ISLANDS: {
    value: "VI",
    zhName: "美属维尔京群岛",
    enName: "Virgin Islands",
    i18nKey: "remote.common.USAState.VIRGIN_ISLANDS"
  },
  MASSACHUSETTS: {
    value: "MA",
    zhName: "马萨诸塞州",
    enName: "Massachusetts",
    i18nKey: "remote.common.USAState.MASSACHUSETTS"
  },
  RHODE_ISLAND: {
    value: "RI",
    zhName: "罗得岛州",
    enName: "Rhode Island",
    i18nKey: "remote.common.USAState.RHODE_ISLAND"
  },
  NEW_HAMPSHIRE: {
    value: "NH",
    zhName: "新罕布什尔州",
    enName: "New Hampshire",
    i18nKey: "remote.common.USAState.NEW_HAMPSHIRE"
  },
  MAINE: {
    value: "ME",
    zhName: "缅因州",
    enName: "Maine",
    i18nKey: "remote.common.USAState.MAINE"
  },
  VERMONT: {
    value: "VT",
    zhName: "佛蒙特州",
    enName: "Vermont",
    i18nKey: "remote.common.USAState.VERMONT"
  },
  CONNECTICUT: {
    value: "CT",
    zhName: "康涅狄格州",
    enName: "Connecticut",
    i18nKey: "remote.common.USAState.CONNECTICUT"
  },
  NEW_JERSEY: {
    value: "NJ",
    zhName: "新泽西州",
    enName: "New Jersey",
    i18nKey: "remote.common.USAState.NEW_JERSEY"
  },
  PENNSYLVANIA: {
    value: "PA",
    zhName: "宾夕法尼亚州",
    enName: "Pennsylvania",
    i18nKey: "remote.common.USAState.PENNSYLVANIA"
  },
  DELAWARE: {
    value: "DE",
    zhName: "特拉华州",
    enName: "Delaware",
    i18nKey: "remote.common.USAState.DELAWARE"
  },
  WASHINGTON_DC: {
    value: "DC",
    zhName: "华盛顿特区",
    enName: "Washington, D.C.",
    i18nKey: "remote.common.USAState.WASHINGTON_DC"
  },
  VIRGINIA: {
    value: "VA",
    zhName: "弗吉尼亚州",
    enName: "Virginia",
    i18nKey: "remote.common.USAState.VIRGINIA"
  },
  MARYLAND: {
    value: "MD",
    zhName: "马里兰州",
    enName: "Maryland",
    i18nKey: "remote.common.USAState.MARYLAND"
  },
  WEST_VIRGINIA: {
    value: "WV",
    zhName: "西弗吉尼亚州",
    enName: "West Virginia",
    i18nKey: "remote.common.USAState.WEST_VIRGINIA"
  },
  NORTH_CAROLINA: {
    value: "NC",
    zhName: "北卡罗来纳州",
    enName: "North Carolina",
    i18nKey: "remote.common.USAState.NORTH_CAROLINA"
  },
  SOUTH_CAROLINA: {
    value: "SC",
    zhName: "南卡罗来纳州",
    enName: "South Carolina",
    i18nKey: "remote.common.USAState.SOUTH_CAROLINA"
  },
  GEORGIA: {
    value: "GA",
    zhName: "佐治亚州",
    enName: "Georgia",
    i18nKey: "remote.common.USAState.GEORGIA"
  },
  FLORIDA: {
    value: "FL",
    zhName: "佛罗里达州",
    enName: "Florida",
    i18nKey: "remote.common.USAState.FLORIDA"
  },
  ALABAMA: {
    value: "AL",
    zhName: "亚拉巴马州",
    enName: "Alabama",
    i18nKey: "remote.common.USAState.ALABAMA"
  },
  TENNESSEE: {
    value: "TN",
    zhName: "田纳西州",
    enName: "Tennessee",
    i18nKey: "remote.common.USAState.TENNESSEE"
  },
  MISSISSIPPI: {
    value: "MS",
    zhName: "密西西比州",
    enName: "Mississippi",
    i18nKey: "remote.common.USAState.MISSISSIPPI"
  },
  KENTUCKY: {
    value: "KY",
    zhName: "肯塔基州",
    enName: "Kentucky",
    i18nKey: "remote.common.USAState.KENTUCKY"
  },
  OHIO: {
    value: "OH",
    zhName: "俄亥俄州",
    enName: "Ohio",
    i18nKey: "remote.common.USAState.OHIO"
  },
  INDIANA: {
    value: "IN",
    zhName: "印第安纳州",
    enName: "Indiana",
    i18nKey: "remote.common.USAState.INDIANA"
  },
  MICHIGAN: {
    value: "MI",
    zhName: "密歇根州",
    enName: "Michigan",
    i18nKey: "remote.common.USAState.MICHIGAN"
  },
  IOWA: {
    value: "IA",
    zhName: "艾奥瓦州",
    enName: "Iowa",
    i18nKey: "remote.common.USAState.IOWA"
  },
  WISCONSIN: {
    value: "WI",
    zhName: "威斯康星州",
    enName: "Wisconsin",
    i18nKey: "remote.common.USAState.WISCONSIN"
  },
  MINNESOTA: {
    value: "MN",
    zhName: "明尼苏达州",
    enName: "Minnesota",
    i18nKey: "remote.common.USAState.MINNESOTA"
  },
  SOUTH_DAKOTA: {
    value: "SD",
    zhName: "南达科他州",
    enName: "South Dakota",
    i18nKey: "remote.common.USAState.SOUTH_DAKOTA"
  },
  NORTH_DAKOTA: {
    value: "ND",
    zhName: "北达科他州",
    enName: "North Dakota",
    i18nKey: "remote.common.USAState.NORTH_DAKOTA"
  },
  MONTANA: {
    value: "MT",
    zhName: "蒙大拿州",
    enName: "Montana",
    i18nKey: "remote.common.USAState.MONTANA"
  },
  ILLINOIS: {
    value: "IL",
    zhName: "伊利诺伊州",
    enName: "Illinois",
    i18nKey: "remote.common.USAState.ILLINOIS"
  },
  MISSOURI: {
    value: "MO",
    zhName: "密苏里州",
    enName: "Missouri",
    i18nKey: "remote.common.USAState.MISSOURI"
  },
  KANSAS: {
    value: "KS",
    zhName: "堪萨斯州",
    enName: "Kansas",
    i18nKey: "remote.common.USAState.KANSAS"
  },
  NEBRASKA: {
    value: "NE",
    zhName: "内布拉斯加州",
    enName: "Nebraska",
    i18nKey: "remote.common.USAState.NEBRASKA"
  },
  LOUISIANA: {
    value: "LA",
    zhName: "路易斯安那州",
    enName: "Louisiana",
    i18nKey: "remote.common.USAState.LOUISIANA"
  },
  ARKANSAS: {
    value: "AR",
    zhName: "阿肯色州",
    enName: "Arkansas",
    i18nKey: "remote.common.USAState.ARKANSAS"
  },
  OKLAHOMA: {
    value: "OK",
    zhName: "俄克拉荷马州",
    enName: "Oklahoma",
    i18nKey: "remote.common.USAState.OKLAHOMA"
  },
  TX: {
    value: "TX",
    zhName: "德克萨斯州",
    enName: "Texas",
    i18nKey: "remote.common.USAState.TX"
  },
  COLORADO: {
    value: "CO",
    zhName: "科罗拉多州",
    enName: "Colorado",
    i18nKey: "remote.common.USAState.COLORADO"
  },
  WYOMING: {
    value: "WY",
    zhName: "怀俄明州",
    enName: "Wyoming",
    i18nKey: "remote.common.USAState.WYOMING"
  },
  IDAHO: {
    value: "ID",
    zhName: "爱达荷州",
    enName: "Idaho",
    i18nKey: "remote.common.USAState.IDAHO"
  },
  UTAH: {
    value: "UT",
    zhName: "犹他州",
    enName: "Utah",
    i18nKey: "remote.common.USAState.UTAH"
  },
  ARIZONA: {
    value: "AZ",
    zhName: "亚利桑那州",
    enName: "Arizona",
    i18nKey: "remote.common.USAState.ARIZONA"
  },
  NEW_MEXICO: {
    value: "NM",
    zhName: "新墨西哥州",
    enName: "New Mexico",
    i18nKey: "remote.common.USAState.NEW_MEXICO"
  },
  NEVADA: {
    value: "NV",
    zhName: "内华达州",
    enName: "Nevada",
    i18nKey: "remote.common.USAState.NEVADA"
  },
  CALIFORNIA: {
    value: "CA",
    zhName: "加利福尼亚州",
    enName: "California",
    i18nKey: "remote.common.USAState.CALIFORNIA"
  },
  US_ARMED_FORCES_EUROPE: {
    value: "AE",
    zhName: "美国驻欧洲军队",
    enName: "US Armed Forces Europe",
    i18nKey: "remote.common.USAState.US_ARMED_FORCES_EUROPE"
  },
  US_ARMED_FORCES_PACIFIC: {
    value: "AP",
    zhName: "美国驻太平洋军队",
    enName: "US Armed Forces Pacific",
    i18nKey: "remote.common.USAState.US_ARMED_FORCES_PACIFIC"
  },
  HAWAII: {
    value: "HI",
    zhName: "夏威夷州",
    enName: "Hawaii",
    i18nKey: "remote.common.USAState.HAWAII"
  },
  AMERICAN_SAMOA: {
    value: "AS",
    zhName: "美属萨摩亚",
    enName: "American Samoa",
    i18nKey: "remote.common.USAState.AMERICAN_SAMOA"
  },
  GUAM: {
    value: "GU",
    zhName: "关岛",
    enName: "Guam",
    i18nKey: "remote.common.USAState.GUAM"
  },
  PALAU: {
    value: "PW",
    zhName: "帕劳",
    enName: "Palau",
    i18nKey: "remote.common.USAState.PALAU"
  },
  FEDERATED_STATES_OF_MICRONESIA: {
    value: "FM",
    zhName: "密克罗尼西亚联邦",
    enName: "Federated States of Micronesia",
    i18nKey: "remote.common.USAState.FEDERATED_STATES_OF_MICRONESIA"
  },
  NORTHERN_MARIANA_ISLANDS: {
    value: "MP",
    zhName: "北马里亚纳群岛",
    enName: "Northern Mariana Islands",
    i18nKey: "remote.common.USAState.NORTHERN_MARIANA_ISLANDS"
  },
  MARSHALL_ISLANDS: {
    value: "MH",
    zhName: "马绍尔群岛",
    enName: "Marshall Islands",
    i18nKey: "remote.common.USAState.MARSHALL_ISLANDS"
  },
  OREGON: {
    value: "OR",
    zhName: "俄勒冈州",
    enName: "Oregon",
    i18nKey: "remote.common.USAState.OREGON"
  },
  WASHINGTON: {
    value: "WA",
    zhName: "华盛顿州",
    enName: "Washington",
    i18nKey: "remote.common.USAState.WASHINGTON"
  },
  ALASKA: {
    value: "AK",
    zhName: "阿拉斯加州",
    enName: "Alaska",
    i18nKey: "remote.common.USAState.ALASKA"
  }
});





// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/USAState.js